<template>
  <div class="StatValue">
    <span class="StatValue-icon" v-if="icon || $slots.icon">
      <!-- @slot Icône -->
      <slot name="icon">
        <ubi-icon size="48" :name="icon" />
      </slot>
    </span>
    <span class="StatValue-content">
      <span>
        <!-- @slot Contenu de la valeur, si non renseigné dans `value` -->
        <span class="StatValue-value">
          <slot>{{ value }}</slot>
        </span>
        <span class="StatValue-subValue" v-if="subValue || $slots.subValue">
          <el-divider direction="vertical" />
          <!-- @slot Contenu de la sous-valeur, si non renseigné dans `sub-value` -->
          <slot name="subValue">{{ subValue }}</slot>
        </span>
      </span>
      <span class="StatValue-label" v-if="label || $slots.label">
        <!-- @slot Unité / label de la valeur, si non renseigné dans `label` -->
        <slot name="label">{{ label }}</slot>
      </span>
    </span>
  </div>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.StatValue {
  @extend .font-secondary;
  display: inline-flex;
  font-size: $font-size-base-alt;
  text-align: left;
  flex-direction: row;

  &-icon {
    @extend .text-primary, .mr-3;
  }
  &-content {
    display: flex;
    flex-direction: column;
  }

  &-value {
    @extend .text-primary, .font-weight-bold;
    font-size: $font-size-lg-alt;
    line-height: $font-size-lg-alt * 0.9;
  }
  &-subValue {
    @extend .font-weight-bold;
    line-height: $font-size-base-alt;
  }

  &-label {
    display: block;
    font-size: $font-size-sm-alt;
    text-transform: uppercase;
  }
  .el-divider {
    background: $black;
    height: 11px;
    vertical-align: baseline;
  }
}

.StatValueDashboard {
  @extend .font-secondary;
  display: inline-flex;
  font-size: 65px;
  text-align: left;
  flex-direction: row;

  &-icon {
    @extend .text-primary, .mr-3;
  }
  &-content {
    display: flex;
    flex-direction: column;
  }

  &-value {
    @extend .text-primary, .font-weight-bold;
    font-size: $font-size-lg-alt;
    line-height: $font-size-lg-alt * 0.9;
  }
  &-subValue {
    @extend .font-weight-bold;
    line-height: $font-size-base-alt;
  }

  &-label {
    display: block;
    font-size: $font-size-sm-alt;
    text-transform: uppercase;
  }
  .el-divider {
    background: $black;
    height: 11px;
    vertical-align: baseline;
  }
}
</style>

<script>
import { Divider } from 'element-ui'
/**
 * Valeur statistique avec label.
 */
export default {
  name: 'UbiStatValue',
  components: { ElDivider: Divider },
  props: {
    /**
     * Valeur
     */
    value: [String, Number],
    /**
     * Sous-valeur ou précision
     */
    subValue: [String, Number],
    /**
     * Unité / label de la valeur
     */
    label: String,
    /**
     * Icône rajouté
     */
    icon: String
  }
}
</script>

<docs>
### Exemples

```jsx
<ubi-stat-value :value="12" />
```

```jsx
<ubi-stat-value value="33%" subValue="+15" label="Produits vendus" />
```

```jsx
<ubi-stat-value icon="tag">
  415
  <span slot="subValue">/ 511</span>
  <span slot="label">Produits - <a href="#">Voir tous les produits</a></span>
</ubi-stat-value>
```
</docs>
